import styled, { css } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

import { StatusColorType } from './StatusTypes';

const mapColor = {
  gray: dsTokens.color.text.neutral.default,
  green: dsTokens.color.text.success.default,
  orange: dsTokens.color.support.orange.strong,
};

export const WrapperText = styled.div<{ color: StatusColorType }>`
  ${({ color, theme }) => css`
    color: ${mapColor[color]};
    margin-top: ${theme.spacing.km1};
  `}
`;

export const WrapperIcon = styled.span<{ icon: string }>`
  ${({ icon, theme }) => css`
    font: inherit;
    display: flex;
    align-items: center;

    fuel-icon {
      margin-right: ${theme.spacing.km2};
      ${icon === 'one-check'
        ? css`
            color: ${mapColor.green};
          `
        : css`
            color: ${theme.color.icon.neutral.weak};
          `}
    }
  `}
`;

export const StatusShowWrapper = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-weight: inherit;
`;
